
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { RoleItemProps } from ".";
import { loading, endLoading } from "store/role";

interface ApiRoleRemoveInputProps {
    ids: number[]
}

type ApiRoleRemoveOutputProps = OutputBaseProps<{ item: RoleItemProps; }>

export const apiRoleRemove = async (data: ApiRoleRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiRoleRemoveOutputProps>("/api/role/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};